import {
  RESPONSIBLE_TYPE,
  UPDATE_TYPE,
  LABEL_TYPE,
  CLOSE_TYPE,
  REOPEN_TYPE,
  TIME_TYPE,
  CREATE_TYPE,
} from 'constants/NotificationConstants';
import Immutable from 'immutable';

// Делаем такой конвертор т.к. в бд пишем не так как нужно :(
const dateTransform = (date) => {
  if (!date) {
    return null;
  }

  const [year, month, day] = date.split('-');
  return `${day}.${month}.${year}`;
};

// Обновляет параметры задачи после получения активити лога из сокетов
export const activityLogTypeHandler = (state, action, taskPath) => {
  if (!state.getIn(taskPath)) {
    return state;
  }

  const { type } = action.payload;
  const {
    header,
    statusId,
    status,
    labelIds,
    userId,
    coPerformerId,
    priority,
    description,
  } = action.payload.content.newValues;

  switch (type) {
    case CREATE_TYPE: {
      const subTasksPath = [...taskPath, 'subTasks'];
      return state
        .setIn([...taskPath, 'hasExpandSubTasks'], true)
        .setIn(subTasksPath, state.getIn(subTasksPath, Immutable.List()).push(parseInt(action.payload.task.taskId)));
    }

    case REOPEN_TYPE:
    case CLOSE_TYPE: {
      if (statusId) {
        return state.setIn([...taskPath, 'statusId'], statusId).setIn([...taskPath, 'status'], status);
      }

      return state;
    }

    case TIME_TYPE: {
      if ('startDate' in action.payload.content.newValues) {
        const date = dateTransform(action.payload.content.newValues.startDate);
        return state.setIn([...taskPath, 'startDate'], date);
      }

      if ('endDate' in action.payload.content.newValues) {
        const date = dateTransform(action.payload.content.newValues.endDate);
        return state.setIn([...taskPath, 'endDate'], date);
      }

      return state;
    }

    case LABEL_TYPE:
    case UPDATE_TYPE: {
      let newState = state;
      if (statusId) {
        newState = newState.setIn([...taskPath, 'statusId'], statusId);
      }

      if (labelIds) {
        newState = newState.setIn([...taskPath, 'labels'], Immutable.fromJS(labelIds));
      }

      if (description) {
        newState = newState.setIn(
          [...taskPath, 'description'],
          Immutable.fromJS(JSON.parse(action.payload.task.description)),
        );
      }

      if (header) {
        newState = newState.setIn([...taskPath, 'header'], header);
      }

      if (coPerformerId) {
        const spectatorsPath = [...taskPath, 'spectators'];
        newState = newState
          .setIn([...taskPath, 'coPerformerId'], coPerformerId)
          // spectators могут отсутствовать у созданной задачи полученной из сокетов
          .setIn(spectatorsPath, state.getIn(spectatorsPath, Immutable.List()).push(coPerformerId));
      }

      if (priority) {
        newState = newState.setIn([...taskPath, 'priority'], priority);
      }

      return newState;
    }
    case RESPONSIBLE_TYPE: {
      if (userId) {
        return state.setIn([...taskPath, 'userId'], userId);
      }

      return state;
    }

    default: {
      return state;
    }
  }
};
